const updateFeatureFlags = {
  toastr: 'Tenant atualizada',
  toastr1: ' foi atualizada com sucesso',
  toastrError: 'Index nao encontrado'
};

export default updateFeatureFlags;
